/**
 * "Has the guest completed the onboarding questionnaire?" flag (device-global, like the
 * tutorial-seen flag). Set on completion; checked at guest-mode entry so a returning guest
 * is not re-shown it. See specs/onboarding-questionnaire/spec.md (AC-12, AC-14).
 */

import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { logger } from '../../helpers/logger.helper';

const QUESTIONNAIRE_KEY = 'has_seen_onboarding_questionnaire';

let _cached: boolean | null = null;

/** Test helper — clear the in-memory cache between cases. */
export function resetQuestionnaireSeenCache(): void {
  _cached = null;
}

export async function hasSeenQuestionnaire(): Promise<boolean> {
  if (_cached !== null) return _cached;
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      _cached = localStorage.getItem(QUESTIONNAIRE_KEY) === 'true';
      return _cached;
    }
    _cached = (await AsyncStorage.getItem(QUESTIONNAIRE_KEY)) === 'true';
    return _cached;
  } catch (error) {
    if (__DEV__) logger.warn('Failed to read questionnaire flag', { error });
    return false;
  }
}

export async function markQuestionnaireSeen(): Promise<void> {
  _cached = true;
  try {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      localStorage.setItem(QUESTIONNAIRE_KEY, 'true');
      return;
    }
    await AsyncStorage.setItem(QUESTIONNAIRE_KEY, 'true');
  } catch (error) {
    if (__DEV__) logger.warn('Failed to persist questionnaire flag', { error });
  }
}
